import { useEffect, useState } from 'react'
import { Box, Card, CardHeader, CardBody, Heading, Text, Spinner, VStack } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { NavigationForm } from '@/components/forms/NavigationForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function EditNavigationPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  const navigationId = id ? Number(id) : undefined
  const [isValidating, setIsValidating] = useState(true)

  useEffect(() => {
    if (!navigationId || Number.isNaN(navigationId)) {
      navigate('/system-settings/navigation', { replace: true })
    } else {
      setIsValidating(false)
    }
  }, [navigationId, navigate])

  const handleSuccess = () => {
    navigate('/system-settings/navigation')
  }

  const handleCancel = () => {
    navigate('/system-settings/navigation')
  }

  if (isValidating || !navigationId) {
    return (
      <AdminLayout>
        <Box p={4}>
          <Card>
            <CardBody>
              <VStack spacing={4} py={8}>
                <Spinner size="xl" color="blue.500" />
                <Text>Loading...</Text>
              </VStack>
            </CardBody>
          </Card>
        </Box>
      </AdminLayout>
    )
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Edit Navigation</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Update navigation information
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <NavigationForm navigationId={navigationId} onSuccess={handleSuccess} onCancel={handleCancel} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}


